import { isLiabilityType } from './account-types.js';

export const BALANCE_EFFECT = Object.freeze({
	Purchase: -1, Withdrawal: -1, Fee: -1, 'Direct Debit': -1,
	Tax: -1, 'Reward Redemption': -1, Transfer: -1, 'Credit Card Payment': -1,
	'Regular Investment': -1,
	Deposit: 1, Refund: 1, Interest: 1, 'Reward Earned': 1, Credit: 1, Charge: 1
});

/**
 * @param {string} type - transaction type
 * @param {string} accountType
 * @returns {number | undefined}
 */
export function computeEffect(type, accountType) {
	const raw = BALANCE_EFFECT[/** @type {keyof typeof BALANCE_EFFECT} */ (type)];
	if (raw === undefined) { return undefined; }
	return isLiabilityType(accountType) ? -raw : raw;
}

/**
 * Return the amount with the sign determined by BALANCE_EFFECT.
 * Deduction types (Purchase, Withdrawal, Transfer, etc.) return negative;
 * deposit types (Deposit, Refund, Interest, etc.) return positive.
 * Falls back to raw amount when the type is not in BALANCE_EFFECT.
 *
 * @param {number} amount
 * @param {string} type
 * @returns {number}
 */
export function signedAmount(amount, type) {
	const effect = BALANCE_EFFECT[/** @type {keyof typeof BALANCE_EFFECT} */ (type)];
	return effect !== undefined ? Math.abs(Number(amount)) * effect : Number(amount);
}
